module.exports = __webpack_public_path__ + "static/media/Foto_(22).0ca7efee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_aus_frueheren_jahren/Foto_(22).jpg
// module id = 534
// module chunks = 0